import noData from "assets/icons/common/nodata.png";
import { default as ModalConfimDelete } from "components/Modal/ModalConfirmDelete";
import TableAG from "components/TableAG/TableAG";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setShowModalConfirmDelete } from "redux/slices/global";
import { deleteToken, getListToken } from "redux/slices/tokenManagement";
import styled from "styled-components";
import DrawerAddToken from "./drawerAddToken";
import DrawerEditToken from "./drawerEditToken";
import NewBreadCrumb from "components/NewBreadCrumb";

const TokenManagement = (props) => {
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const dispatch = useDispatch();
  const [record, setRecord] = useState({});
  const [configID, setConfigID] = useState("");
  const { t } = useTranslation();
  const { listToken } = useSelector((state) => state.tokenManagementReducer);
  const [searchKey] = useState({});
  const [search, setSearch] = useState({});
  const { userRuleGlobal } = useSelector((state) => state.userReducer);

  useEffect(() => {
    dispatch(
      getListToken({
        limit: 100,
        page: 1,
        search_data: {},
      })
    );
    // eslint-disable-next-line
  }, []);

  const checkRule = (rule) => {
    if (
      userRuleGlobal.find(
        (item) =>
          _.get(item, "domain", "") === "token_management" &&
          item.actions.includes(rule)
      )
    )
      return true;
    else return false;
  };

  const columns = [
    {
      headerName: t("tokenManagement.name"),
      field: "name",
      itemDetails: {
        type: "inputSearch",
        ID: "name",
      },
      suppressMovable: true,
    },
    {
      headerName: t("tokenManagement.rateLimitPerMinute"),
      field: "ratelimit_per_minute",
      itemDetails: {
        type: "inputSearch",
        ID: "ratelimit_per_minute",
      },
      suppressMovable: true,
    },
    {
      headerName: t("tokenManagement.expiredDate"),
      field: "expired_date",
      itemDetails: {
        type: "inputSearch",
        ID: "expired_date",
      },
      suppressMovable: true,
    },
  ];

  const handleEditRecord = (record) => {
    console.log(record);
    setRecord(record);
    setOpenEdit(true);
  };

  const handleDeleteRecord = (record) => {
    console.log(record);
    setConfigID(record._id);

    dispatch(setShowModalConfirmDelete(true));
  };

  const handleSearch = (value, newValue) => {
    console.log(value, newValue);
    let temp = { ...search };
    temp[value.ID] = newValue;
    setSearch({ ...temp });
  };

  const [keyWord, setKeyWord] = useState({});

  useEffect(() => {
    let temp = { ...keyWord, ...search };
    setKeyWord(temp);
    // eslint-disable-next-line
  }, [search]);

  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const [dataFilter, setDataFilter] = useState([]);

  useEffect(() => {
    console.log(listToken?.data, keyWord);
    let tempData = listToken?.data?.map((item, idx) => {
      return { ...item, ratelimit_per_minute: item.ratelimit_per_minute + "" };
    });
    console.log(tempData);

    const dataFilter = tempData?.filter((item) => {
      const searchKeyLower = _.get(keyWord, "name")
        ? removeAccents(
            _.get(keyWord, "name", "")
              ? _.get(keyWord, "name", "").toLowerCase()
              : ""
          )
        : "";
      const itemKeyLower = removeAccents(
        _.get(item, "name", "") ? _.get(item, "name", "").toLowerCase() : ""
      );

      const searchExpired = _.get(keyWord, "expired_date")
        ? removeAccents(
            _.get(keyWord, "expired_date", "")
              ? _.get(keyWord, "expired_date", "").toLowerCase()
              : ""
          )
        : "";

      const itemExpiredLower = removeAccents(
        _.get(item, "expired_date", "")
          ? _.get(item, "expired_date", "").toLowerCase()
          : ""
      );

      const searchRateLower = _.get(keyWord, "ratelimit_per_minute")
        ? removeAccents(
            _.get(keyWord, "ratelimit_per_minute", "")
              ? _.get(keyWord, "ratelimit_per_minute", "").toLowerCase()
              : ""
          )
        : "";
      const itemRateLower = removeAccents(
        _.get(item, "ratelimit_per_minute", "")
          ? _.get(item, "ratelimit_per_minute", "").toLowerCase()
          : ""
      );

      // const searchParent = _.get(searchKey, "parent_record_id");

      return (
        !(searchKeyLower && !itemKeyLower.includes(searchKeyLower)) &&
        !(searchExpired && !itemExpiredLower.includes(searchExpired)) &&
        !(searchRateLower && !itemRateLower.includes(searchRateLower))
      );
    });
    console.log(dataFilter);
    setDataFilter(dataFilter);
  }, [keyWord, listToken]);
  const breadcrumbs = [
    { url: "/settings", label: t("settings.settings") },
    { url: "", label: t("tokenManagement.tokenManagement") },
  ];
  return (
    <Wrapper>
      {/* <NewBreadCrumb>
        <span>{t("common.settings")}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="5"
          height="5"
          viewBox="0 0 5 5"
          fill="none"
          style={{ marginTop: "4px" }}
        >
          <circle cx="2.94141" cy="2.91406" r="2" fill="#919EAB" />
        </svg>
        <span>{t("tokenManagement.tokenManagement")}</span>
      </NewBreadCrumb> */}
      <TopComp>
        <NewBreadCrumb items={breadcrumbs} />

        <div className="add-new-btn">
          {checkRule("create") && (
            <button
              onClick={() => {
                setOpen(true);
              }}
            >
              + {t("tokenManagement.addNewToken")}
            </button>
          )}
        </div>
      </TopComp>

      {listToken?.data?.length > 0 ? (
        <DataWrapper checkRule={checkRule}>
          <TableAG
            TableName={"select_droplist_setting"}
            cols={columns}
            dataSource={dataFilter || []}
            handleEditRecord={handleEditRecord}
            handleDeleteRecord={handleDeleteRecord}
            handleSearch={handleSearch}
            onChangeSwitch={() => {}}
            ListHiddenAction={[
              "view",
              `${checkRule("edit") ? "" : "edit"}`,
              `${checkRule("delete") ? "" : "delete"}`,
            ]}
            hidenSelect={true}
            hiddenOptionCol={true}
            widthColAction={100}
            searchKey={searchKey}
          />
        </DataWrapper>
      ) : (
        <NoData>
          <img alt="noData" src={noData} />

          <span>
            {t("object.noObject")}{" "}
            <span style={{ color: "#20a2a2" }}>Token</span>
          </span>

          {checkRule("create") && (
            <button
              onClick={() => {
                setOpen(true);
              }}
            >
              + {t("tokenManagement.addNewToken")}
            </button>
          )}
        </NoData>
      )}

      <DrawerAddToken open={open} setOpen={setOpen} />
      <DrawerEditToken open={openEdit} setOpen={setOpenEdit} record={record} />

      <ModalConfimDelete
        title={"this token"}
        decs={t("common.descriptionDelete")}
        methodDelete={deleteToken}
        dataDelete={{
          config_id: configID,
        }}
        setShowModalDelete={() => {}}
      />
    </Wrapper>
  );
};

export default TokenManagement;
// const NewBreadCrumb = styled.div`
//   display: flex;
//   align-items: center;
//   span {
//     margin: 0px 8px;
//     margin-top: 4px;
//     font-size: 16px;
//     font-family: var(--roboto-500);
//     color: #637381;
//     :last-child {
//       color: #212b36;
//     }
//   }
//   margin-bottom: 16px;
// `;

const Wrapper = styled.div`
  padding: 16px;
  width: 100%;
  height: 100%;
`;

const NoData = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  padding-top: 40px;
  img {
    width: 100px;
    height: 100px;
    margin-bottom: 8px;
  }
  span {
    font-size: 14px;
    font-family: var(--roboto-400);
    margin-bottom: 16px;
  }
  button {
    padding: 4px 12px 4px 12px;
    color: white;
    font-size: 16px;
    font-family: var(--roboto-400);
    background-color: ${(props) => props.theme.main};
    border: none;
    border-radius: 8px;
    cursor: pointer;
  }
`;

const DataWrapper = styled.div`
  margin-top: 16px;
  max-height: calc(100vh - 180px);
  height: 100%;
  background-color: #fff;
  padding: 10px 10px 4px 10px;
  border-radius: 6px 6px 0 0;
  /* padding-top: ${(props) =>
    props.checkRule("create") ? "65px" : "10px"}; */
  button {
    padding: 4px 12px 4px 12px;
    color: white;
    font-size: 16px;
    font-family: var(--roboto-400);
    background-color: ${(props) => props.theme.main};
    border: none;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 24px;
  }

  .add-new-btn {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: -55px;
  }
`;

const TopComp = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    padding: 4px 12px 4px 12px;
    color: white;
    font-size: 16px;
    font-family: var(--roboto-400);
    background-color: ${(props) => props.theme.main};
    border: none;
    border-radius: 8px;
    cursor: pointer;
  }
`;
